import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import DrawerItem from './menu-drawer-item'
import {CloseIcon, Logo} from 'components/static/icons'
import {Link} from 'react-router-dom'
import styled from 'styled-components'
import './menu.css'




const styles = {
  drawerPosition : {
    position: 'fixed',
    top: 0,
    right: 0,
    width: 300,
    height: '100%',
    background: 'linear-gradient(-45deg, #ddd, #eee)',
    backgroundColor: 'azure',
    zIndex: 4,
  },
}


const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  background-color: #333;
`;

const More = styled.h4`
  width: 100%;
  color: white;
  padding-left: 20px;
`;

const CloseWrapper = styled.div`
  width: 20px;
  height: 20px;
  padding-right: 20px;
  cursor: pointer;
`;

const LogoWrapper = styled.div`
  margin-top: 35px;
  height: 40px;
`;

class MenuDrawer extends React.Component {
  componentDidMount() {
    this.menu.classList.add('visible');
  }

  //-- only works when not using redux
  componentWillReceiveProps(nextProps){
    this.menu.classList.add('visible');
  }

  render() {
    const isAuthed = this.props.auth.loggedIn;
    const menuItems = [
      {
        text: isAuthed ? "My ballot" : "Sign up",
        to: isAuthed ? "/user" : "/user/login" //-- need to connect this to actually logging out
      },
      {
        text: 'subscribe',
        to: '/subscribe'
      },
    ];

    const { toggleVisibility } = this.props;
    const items = menuItems.map( (item, i) => (
      <DrawerItem key={i} toggleVisibility={toggleVisibility} text={item.text} to={item.to}/>
    ));
    return(
      <div id='menu-transition' ref={(el) => this.menu = el} style={styles.drawerPosition}>
        <TopBar>
          <More>More things to see</More>
          <CloseWrapper onClick={()=>{toggleVisibility(false)}}>
            <CloseIcon color='#fff'/>
          </CloseWrapper>
        </TopBar>
        {items}
        <Link to='/' onClick={()=>{toggleVisibility(false)}}>
          <LogoWrapper><Logo color='#fff'/></LogoWrapper>
        </Link>
      </div>
    )
  }
}
        // <DrawerItem toggleVisibility={this.props.toggleVisibility} text='Support us with $$$' to='/halp/contribute'/>
        // <DrawerItem toggleVisibility={this.props.toggleVisibility} text='Work with us' to='/jobs/developer-designer'/>

MenuDrawer.propTypes = {
  toggleVisibility: PropTypes.func.isRequired,
}

MenuDrawer.contextTypes = {
  store: PropTypes.object
};

function mapStateToProps(state) {
  const auth = state.auth;
  return { auth };
}

export default connect(mapStateToProps, {})(withRouter(MenuDrawer));




// WEBPACK FOOTER //
// ./src/components/interactive/menu/menu-drawer.js